import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import themeGet from "@styled-system/theme-get";
import { WrapperStyle, BodyStyle } from "../../../layouts/layout.style";

const FooterStyle = styled("footer", {
  fixed: PropTypes.bool,
})`
  display: flex;
  flex: 0 0 50px;
  flex-wrap: wrap;
  align-items: center;
  height: 50px;
  padding: 0 16px;
  color: ${themeGet("colors.footer.color", "#3c4b64")};
  background: ${themeGet("colors.footer.backgroundColor", "#ebedef")};
  border-top: 1px solid ${themeGet("colors.footer.borderColor", "#d8dbe0")};
  
  ${({ fixed }) => fixed && css`
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1030;
    
    ${WrapperStyle} & {
      position: sticky;
      bottom: 0;

      @media all and (-ms-high-contrast: none) {
        position: fixed;
        margin: inherit;
        
        & ~ ${BodyStyle} {
          margin-bottom: 49px;
        }
      }
    }
  `}
`;

export { FooterStyle };
